module.exports = __webpack_public_path__ + "static/media/FE2100-51E.557ac203.png";